const digitalStyleGuideScreens = [
  {
    id: "digital-standards-colour",
    kind: "desktop",
    slot: "desktop",
    src: "/images/cooperators/case-studies/digital-style-guide/colour-foundations.webp",
    alt: "Co-operators Digital Standards colour foundations with accessible light and dark mode palettes",
    caption: "Accessible colour foundations for light and dark experiences",
    frame: {
      x: 3,
      y: 2,
      width: 84,
      height: 84,
      rotation: 0,
      zIndex: 1,
      cropX: 50,
      cropY: 28,
    },
  },
  {
    id: "digital-standards-typography",
    kind: "desktop",
    slot: "tertiary",
    src: "/images/cooperators/case-studies/digital-style-guide/typography-foundations.webp",
    alt: "Co-operators Digital Standards typography hierarchy for desktop and mobile interfaces",
    caption: "A practical, readable typography hierarchy across screen sizes",
    frame: {
      x: 28,
      y: 31,
      width: 59,
      height: 67,
      rotation: 0,
      zIndex: 3,
      cropX: 50,
      cropY: 18,
    },
  },
  {
    id: "digital-standards-styles",
    kind: "desktop",
    slot: "primary",
    src: "/images/cooperators/case-studies/digital-style-guide/style-foundations.webp",
    alt: "Co-operators Digital Standards interface foundations for radius, spacing, opacity, and shadows",
    caption: "Reusable interface foundations for spacing, depth, and shape",
    frame: {
      x: 72,
      y: 20,
      width: 26,
      height: 76,
      rotation: 3,
      zIndex: 4,
      cropX: 50,
      cropY: 18,
    },
  },
];

export const digitalStyleGuideFoundationGallery = digitalStyleGuideScreens
  .slice(0, 2)
  .map((screen) => ({
    id: `${screen.id}-gallery`,
    src: screen.src,
    alt: screen.alt,
    caption: screen.caption,
  }));

export default digitalStyleGuideScreens;
